import { computed, ref } from 'vue'

export function useTitleInfo(title) {
  // Compute the release year for movies or air dates for TV shows.
  const releaseYear = computed(() => {
    if (!title.value) return ''

    // Handle movies
    if (title.value?.release_date) {
      return title.value.release_date
        ? new Date(title.value.release_date).getFullYear()
        : ''
    }

    // Handle TV shows
    if (title.value?.first_air_date) {
      const firstAirYear = title.value.first_air_date
        ? new Date(title.value.first_air_date).getFullYear()
        : 'N/A'

      if (title.value?.next_episode_to_air) {
        // If the show is ongoing
        return `${firstAirYear} - Present`
      } else if (title.value.last_air_date) {
        // If the show has ended
        const lastAirYear = new Date(title.value.last_air_date).getFullYear()
        // Avoid repeating the same year (e.g., "2024 - 2024")
        return firstAirYear === lastAirYear
          ? `${firstAirYear}`
          : `${firstAirYear} - ${lastAirYear}`
      }
      return firstAirYear
    }

    return ''
  })

  // Get the certification for US (first) and then UK (GB) from the release dates for movies
  const certification = computed(() => {
    if (!title.value) return ''
    if (
      title.value.release_dates &&
      Array.isArray(title.value.release_dates.results)
    ) {
      const usRelease = title.value.release_dates.results.find(
        (release) => release.iso_3166_1 === 'US'
      )
      if (
        usRelease &&
        Array.isArray(usRelease.release_dates) &&
        usRelease.release_dates.length > 0
      ) {
        return usRelease.release_dates[0].certification || 'N/A'
      }

      const ukRelease = title.value.release_dates.results.find(
        (release) => release.iso_3166_1 === 'GB'
      )
      if (
        ukRelease &&
        Array.isArray(ukRelease.release_dates) &&
        ukRelease.release_dates.length > 0
      ) {
        return ukRelease.release_dates[0].certification || 'N/A'
      }
    }
    return null
  })

  const originCountry = computed(() => {
    if (!title || !title.value) return ''
    return Array.isArray(title.value?.origin_country)
      ? title.value.origin_country.join(', ')
      : title.value?.origin_country || ''
  })

  const displayTitle = computed(() => {
    if (!title || !title.value) return ''
    return title.value?.title || title.value?.name || ''
  })

  return {
    releaseYear,
    certification,
    originCountry,
    displayTitle
  }
}
